import { useState } from "react";
import { FaTimes, FaMicrochip } from "react-icons/fa";
import INVERTER_BRANDS from "../constants/inverterBrands";
import { registerDevice } from "../services/devices";
import "../styles/adddevicemodal.css";

export default function AddDeviceModal({ onClose, onAdded }) {

    const [serial, setSerial] = useState("");
    const [brand, setBrand] = useState("");
    const [model, setModel] = useState("");
    const [nickname, setNickname] = useState("");

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const canSubmit =
        serial.trim() && brand && model.trim() && !loading;

    async function handleSubmit(e) {

        e.preventDefault();

        if (!canSubmit) return;

        setError("");
        setLoading(true);

        try {

            const res = await registerDevice({
                serial: serial.trim(),
                brand,
                model: model.trim(),
                nickname: nickname.trim() || null
            });

            onAdded(res.data.device);

        } catch (err) {

            // Backend sends back exactly what should be shown:
            // "Device not found." / "Device already registered." / etc.
            setError(
                err.response?.data?.message ||
                "Something went wrong. Please try again."
            );

        } finally {

            setLoading(false);

        }

    }

    return (

        <div className="modalOverlay" onClick={onClose}>

            <div
                className="modalCard"
                onClick={(e) => e.stopPropagation()}
            >

                <div className="modalHeader">

                    <h2><FaMicrochip /> Add Device</h2>

                    <button
                        className="modalClose"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <FaTimes />
                    </button>

                </div>

                <form onSubmit={handleSubmit}>

                    <label>Device ID</label>
                    <input
                        type="text"
                        placeholder="e.g. INV000001"
                        value={serial}
                        onChange={(e) => setSerial(e.target.value)}
                        autoFocus
                    />

                    <label>Inverter Brand</label>
                    <select
                        value={brand}
                        onChange={(e) => setBrand(e.target.value)}
                    >
                        <option value="">Select a brand</option>
                        {INVERTER_BRANDS.map(b => (
                            <option key={b} value={b}>{b}</option>
                        ))}
                    </select>

                    <label>Inverter Model</label>
                    <input
                        type="text"
                        placeholder="e.g. Axpert King 5.5kW"
                        value={model}
                        onChange={(e) => setModel(e.target.value)}
                    />

                    <label>Nickname <span>(optional)</span></label>
                    <input
                        type="text"
                        placeholder="e.g. Rooftop Inverter"
                        value={nickname}
                        onChange={(e) => setNickname(e.target.value)}
                    />

                    {error && <div className="modalError">{error}</div>}

                    <button
                        type="submit"
                        className="modalSubmit"
                        disabled={!canSubmit}
                    >
                        {loading ? "Adding..." : "Add Device"}
                    </button>

                </form>

            </div>

        </div>

    );

}
